import { render, staticRenderFns } from "./WidgetsDisbursementMasterView.vue?vue&type=template&id=2f8ed1ba&scoped=true"
import script from "./WidgetsDisbursementMasterView.vue?vue&type=script&lang=js"
export * from "./WidgetsDisbursementMasterView.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDisbursementMasterView.vue?vue&type=style&index=0&id=2f8ed1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ed1ba",
  null
  
)

export default component.exports